import moment from 'moment';

import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
  signal,
} from '@angular/core';
import { GridComponent } from '@progress/kendo-angular-grid';
import {
  SortDescriptor,
  State,
  toODataString,
} from '@progress/kendo-data-query';

import { environment } from '@ups/xplat/core';
import { FilterDescriptorEx } from '@ups/xplat/features';
import { ReleaseNotePopupComponent } from '../release-note-popup/release-note-popup.component';
import { ReleaseNoteService } from '@ups/xplat/core';
import { Communication, CommunicationTypeEnum } from '@ups/xplat/api/dto';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-past-releases-table',
  templateUrl: './past-releases-table.component.html',
  styleUrls: ['./past-releases-table.component.scss'],
  standalone: false,
})
export class PastReleasesTableComponent implements OnInit {
  @ViewChild(GridComponent) grid: GridComponent;
  @ViewChild(ReleaseNotePopupComponent) popup: ReleaseNotePopupComponent;

  pageSizes = [5, 10, 15];
  initialPageSize = this.pageSizes[1];

  sortDescriptors: SortDescriptor[] = [
    {
      field: 'lastUpdated',
      dir: 'desc',
    },
  ];

  filters: FilterDescriptorEx[] = [
    {
      operator: 'eq',
      convertToString: false,
      value: true,
      field: 'bPublished',
    },
    {
      operator: 'eq',
      convertToString: false,
      value: CommunicationTypeEnum.ReleaseNote,
      field: 'communicationTypeId',
    },
  ];

  gridDataState: State = {
    filter: { logic: 'and', filters: this.filters },
    group: [],
    skip: 0,
    sort: this.sortDescriptors,
    take: this.initialPageSize,
  };

  gridSkip = 0;

  // WI 31712: written in the grid-data subscription, so signals for OnPush.
  readonly data = signal<Communication[]>([]);
  readonly loading = signal(false);

  constructor(private releaseNotesService: ReleaseNoteService) {}

  ngOnInit() {
    this.loadAppData();
  }

  public gridDataStateChanged(state: State): void {
    this.gridDataState = state;
    // console.dir(state);
    this.loadAppData();
  }

  loadAppData() {
    this.loading.set(true);
    this.releaseNotesService
      .getReleaseNotes(
        environment.security.appId,
        this.gridDataState ? toODataString(this.gridDataState) : null
      )
      .subscribe((x) => {
        x.value.forEach((r) => {
          r.lastUpdated = moment.utc(r.lastUpdated).local().toDate();
          r.releaseDate = moment.utc(r.releaseDate).local().toDate();
        });
        this.data.set(x.value);
        this.loading.set(false);
      });
  }

  showReleaseNote(rn: Communication) {
    this.releaseNotesService
      .getFullReleaseNote(rn.communicationId)
      .subscribe((x) => {
        this.popup.showReleasePopup(x, true);
      });
  }
}
